import ListStore from '@/store/core/ListStore';
import { action, computed } from 'mobx';
import services from '@/api/services';
import { taxpayerGraphParse } from '@/utils/parser';
import { TaxpayerIncome } from '@/store/types';
import { BarChartItem } from '@/types/charts';

export default class TaxpayerIncomeYearStore extends ListStore<TaxpayerIncome> {
  @computed get processedData(): TaxpayerIncome<BarChartItem> | undefined {
    if (!this.data) return;
    return {
      ...this.data,
      incomeAggregates: taxpayerGraphParse(this.data.incomeAggregates),
    };
  }

  @action.bound async fetch(id: string, period: string) {
    this.isFetching = true;
    try {
      const { data } = await services.selfEmployee.getTaxpayerIncome(id, {
        month: period,
        type: 'YEAR',
      });
      this.data = data;
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
